import { html, nothing } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { TefComsConsent } from '../../tef-coms-consent';
import { doToggle, localDate, localTime } from '../util';
import { ConsentType } from '../../../types/common';

export const consentTemplate = (consentClasses: string[], checkboxClasses: string[], consent: ConsentType, disabled: boolean, comsConsent: TefComsConsent) => html`
<one-stack gap="xs">
  <div class="${consentClasses.join(' ')}">
    ${consent.hintBefore ? html`<div class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</div>` : nothing}  
    <one-stack gap="${!disabled ? 'xs' : 'none'}">
      ${!disabled ? html`
        <one-group y="start" gap="xxs" wrap="noWrap" align-items="flex-start" >
          <one-checkbox
            .checked=${consent.granted}
            @change="${doToggle({ id: consent.id })}"
              id="${consent.id}"
              name="${consent.id}"
              variant="outline"
          >
          </one-checkbox>
          <one-stack gap="sm">
            <one-content>
              ${unsafeHTML(consent.scope)}
            </one-content>
            ${comsConsent.features}
          </one-stack>
        </one-group>
      ` : html`
        <one-list icon="${consent.granted ? 'check' : 'cancel'}" size="lg">
          <one-list-item>
            <one-icon name="${consent.granted ? 'check' : 'cancel'}" size="lg" variant="outline" slot="icon"></one-icon>
            <one-content>
              ${unsafeHTML(consent.scope)}
            </one-content>
            ${comsConsent.features}
          </one-list-item>
        </one-list>
      `}
      ${consent.clientDisplay && localDate(consent.date) ? html`
        <one-list-item>
          <one-icon name="clock" size="sm" variant="outline" slot="icon"></one-icon>
          <one-content>
            <one-text size="xs"> Letzte Änderung am
              ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.clientDisplay}
            </one-text>
          </one-content>
        </one-list-item>
      ` : nothing}
      ${consent.hintAfter ? html`<one-text as="div" class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</one-text>` : nothing}
    </one-stack>
  </div>
</one-stack>
<style>
  .form-row--group {
    border: 1px solid;
    padding: 16px;
  }
</style>`;

export default consentTemplate;
